import { Inject, Injectable } from '@angular/core';

import { ENVIRONMENT } from '@lyra/app/core/providers/environment.provider';
import { Environment } from '@lyra/environments/env';
import { CookieService } from 'ngx-cookie-service';

/** How long a successful-checkout marker stays valid — it gates the vmain login page. */
const SUCCESS_COOKIE_TTL_MS = 24 * 60 * 60 * 1000;

/**
 * Persists the checkout result in a cookie so the post-payment login page stays reachable for 24h
 * (survives reloads and the store reset). Written by {@link orderStatusGuard}, read by the login guard.
 */
@Injectable({ providedIn: 'root' })
export class AuthStatusCookieService {
  private readonly _cookieName = 'auth_real_user';

  constructor(
    private _cookieService: CookieService,
    @Inject(ENVIRONMENT) private _env: Environment,
  ) {}

  /** Mark the checkout as successful for the next 24 hours. */
  setSuccess(): void {
    this._cookieService.set(
      this._cookieName,
      'true',
      new Date(Date.now() + SUCCESS_COOKIE_TTL_MS),
      '/',
      this._env.cookieDomain,
    );
  }

  /** True while a successful-checkout cookie is present. */
  isSuccess(): boolean {
    return this._cookieService.get(this._cookieName) === 'true';
  }

  /** Clear the successful-checkout cookie. */
  clear(): void {
    this._cookieService.delete(this._cookieName, '/', this._env.cookieDomain);
  }
}
